import { reviews } from "../../../mocks/guaData";

function Stars({ score }: { score: number }) {
  const full = Math.floor(score);
  return (
    <div className="flex gap-0.5 text-amber-500" aria-label={`评分 ${score} 分`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={i < full ? "ri-star-fill text-sm" : "ri-star-line text-sm"}
          aria-hidden="true"
        ></i>
      ))}
    </div>
  );
}

const avatarColors = [
  "bg-accent-500",
  "bg-primary-500",
  "bg-secondary-500",
  "bg-accent-600",
];

export default function Reviews() {
  return (
    <section id="reviews" className="w-full bg-background-50 py-14 md:py-20" aria-label="用户口碑">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-primary-600">Reviews</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            用过的人怎么说？真实口碑一览
          </h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            我们把真实用户的评价做了分类整理，涵盖追星党、上班族、重度玩家与内容创作者，
                帮你从不同视角了解吃瓜神器的实际体验。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {reviews.map((r, i) => (
            <figure key={r.name} className="flex flex-col rounded-lg bg-background-100 p-6 ring-1 ring-background-200">
              <Stars score={r.score} />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold text-white ${avatarColors[i % avatarColors.length]}`}
                >
                  {r.avatar}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{r.name}</p>
                  <p className="text-xs text-foreground-600">{r.tag}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}